// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-7769ed63] {\n  fill: #fff\n}\n.st43[data-v-7769ed63] {\n  fill: #5dd02a\n}\n", ""]);
// Exports
module.exports = exports;
